import React, { useState } from "react";
import Login from "../component/Login";
import { ILoginPostBody } from "../types/post/Interface";
import {
  GoogleLoginService,
  postUserLoginService,
} from "../services/LoginService";
import { ILoginApiResp } from "../types/get/LoginType";
import { Apinames } from "../utils/Apiname";
import useUserStore from "../utils/userStore";
import { useNavigate } from "react-router-dom";
import { setCookie } from "../utils/Common";

import { auth, provider } from "../utils/Config";
import { signInWithPopup } from "firebase/auth";

const LoginScreen = () => {
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const setUser = useUserStore((state) => state.setUser);
  const navigate = useNavigate();

  const onLoginPressed = async (value: ILoginPostBody) => {
    try {
      setIsLoading(true);
      let response: ILoginApiResp = await postUserLoginService(
        Apinames.login,
        value
      );
      console.log("response ::", response);
      if (response.result) {
        console.log("resspon");
        setUser(response.result);
        global.authToken = response.result.token;
        setCookie(response.result);
        window.location.href = "/";
      }
    } catch (error: any) {
      console.log("onSubmitPressed error ::", error);
      updateErrorMessage(error);
    } finally {
      setIsLoading(false);
    }
  };

  const updateErrorMessage = (error?: any) => {
    if (error) setErrorMessage(error);
    else setErrorMessage("");
  };

  const onPressgoogleLogin = async () => {
    try {
      const response = await signInWithPopup(auth, provider);
      if (response) {
        let accessToken = (await response.user.getIdTokenResult(true)).token;

        onSocialLogin(accessToken);
      }
    } catch (error) {
      console.error("Error during sign-in:", error);
    }
  };

  const onSocialLogin = async (accessToken: string) => {
    try {
      const data = {
        idToken: accessToken,
      };

      const _response: any = await GoogleLoginService(
        Apinames.usersGoogleSignin,
        data
      );

      if (_response.result === "redirect to profile") {
        navigate("/googlesignup", { state: { idToken: accessToken } });
      } else {
        setUser(_response.result);
        global.authToken = _response.result.token;
        setCookie(_response.result);
        window.location.href = "/";
      }
    } catch (error) {
      updateErrorMessage(error);
    }
  };


  return (
    <Login
      errorMessage={errorMessage}
      isLoading={isLoading}
      onLoginPressed={onLoginPressed}
      updateErrorMessage={updateErrorMessage}
      onPressgoogleLogin={onPressgoogleLogin}
    />
  );
};

export default LoginScreen;
